'use client';

import { mainBugsnag } from 'helpers/bugsnag';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    mainBugsnag.notify(error, (event) => {
      event.context = 'Error Boundary (public)';
      if (error.digest) {
        event.addMetadata('Error', { digest: error.digest });
      }
    });
  }, [error]);

  return (
    <div className='flex flex-col items-center justify-center min-h-screen bg-teal-800 text-white px-4'>
      <h2 className='text-2xl font-semibold mb-2'>Something went wrong</h2>
      <p className='text-white/70 mb-6'>An unexpected error occurred. Please try again.</p>
      <button
        onClick={reset}
        className='px-6 py-2 bg-white text-teal-800 font-semibold rounded hover:bg-white/90 transition-colors'>
        Try again
      </button>
    </div>
  );
}
